module.exports = __webpack_public_path__ + "static/media/worldMap.109bac0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/worldMap.svg
// module id = 361
// module chunks = 0